import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCommon } from "@obg/common.config";
import { ConfigService } from "@obg/ngx.global";

@Injectable({
	providedIn: "root",
})
export class AlternativeLayoutConfigService {
	constructor(private config: ConfigService<ObgConfigFeAdaptiveClientCommon>) {}

	alternativeButtonsEnabled(): boolean {
		return this.config.get((x) => x.common.alternativeLayout.alternativeButtonsEnabled, false);
	}
}
